import EntityType from "@mapmycustomers/shared/enum/EntityType";
import Company from "@mapmycustomers/shared/types/entity/Company";
import Person from "@mapmycustomers/shared/types/entity/Person";

interface StopEntityRef {
  accountId?: Company["id"];
  contactId?: Person["id"];
  entity: EntityType | null;
}

const extractRouteStopEntityIds = (
  stops: ReadonlyArray<StopEntityRef>
): { companyIds: Company["id"][]; personIds: Person["id"][] } => {
  const companyIds: Company["id"][] = [];
  const personIds: Person["id"][] = [];
  stops.forEach((stop) => {
    if (stop.entity === EntityType.COMPANY && stop.accountId != null) {
      companyIds.push(stop.accountId);
    } else if (stop.entity === EntityType.PERSON && stop.contactId != null) {
      personIds.push(stop.contactId);
    }
  });
  return { companyIds, personIds };
};

export default extractRouteStopEntityIds;
